import { Check } from 'lucide-react';

export type CreatorStep = 1 | 2 | 3 | 4;

type StepConfig = {
  index: CreatorStep;
  title: string;
  caption: string;
};

const STEPS: ReadonlyArray<StepConfig> = [
  { index: 1, title: 'Basics', caption: 'Name & card theme' },
  { index: 2, title: 'Pricing', caption: 'Validity & price' },
  { index: 3, title: 'Benefit', caption: 'Discount, visits or points' },
  { index: 4, title: 'Perks', caption: 'What members get' },
];

type Props = {
  activeStep: CreatorStep;
  stepReached: CreatorStep;
  onChange: (next: CreatorStep) => void;
};

const StepNavRail = ({ activeStep, stepReached, onChange }: Props) => (
  <nav className="creator-rail" aria-label="Wizard steps">
    <div className="creator-rail__heading">STEP {activeStep} OF 4</div>
    <ol className="creator-rail__list">
      {STEPS.map((step) => {
        const isActive = step.index === activeStep;
        const isCompleted = step.index < stepReached;
        const isReachable = step.index <= stepReached;
        return (
          <li
            key={step.index}
            className={`creator-rail__item${isActive ? ' creator-rail__item--active' : ''}${isCompleted ? ' creator-rail__item--completed' : ''}`}
          >
            <button
              type="button"
              className="creator-rail__button"
              onClick={() => isReachable && onChange(step.index)}
              disabled={!isReachable}
              data-testid={`creator-step-${step.index}`}
              aria-current={isActive ? 'step' : undefined}
            >
              <span className="creator-rail__badge" aria-hidden="true">
                {isCompleted ? <Check size={14} /> : step.index}
              </span>
              <span className="creator-rail__text">
                <span className="creator-rail__title">{step.title}</span>
                <span className="creator-rail__caption">{step.caption}</span>
              </span>
            </button>
          </li>
        );
      })}
    </ol>
  </nav>
);

export default StepNavRail;
